module.exports = __webpack_public_path__ + "media/scholarship_winners/william-m-1f7d3706.png";